export const DROP_DOWN_LIST_LIMIT = 15
export const PER_PAGE_ITEMS = 7
